import { Component } from '@angular/core';

@Component({
  selector: 'mpp-svg-sprite',
  templateUrl: './svg-sprite.component.html',
  styleUrls: ['./svg-sprite.component.scss'],
  standalone: false,
})
export class SvgSpriteComponent {}
